export const SET_SELECTED_PRODUCT = 'SET_SELECTED_PRODUCT';

export const setSelectedProduct = (payload) => ({
  type: SET_SELECTED_PRODUCT,
  payload,
});
